import { useDispatch } from 'react-redux';
import { Stack, Box, Tooltip } from '@mui/material';

import * as actionTypes from 'store/actions';

const themeColors = [
    { name: 'blue', color: '#1976d2' },
    { name: 'green', color: '#2e7d32' },
    { name: 'orange', color: '#f57c00' },
    { name: 'red', color: '#d32f2f' },
    { name: 'purple', color: '#7b1fa2' },
    { name: 'pink', color: '#c2185b' },
    { name: 'teal', color: '#00897b' },
    { name: 'indigo', color: '#3949ab' },
    { name: 'cyan', color: '#00acc1' },
    { name: 'brown', color: '#6d4c41' }
];

const ThemeSwitcher = () => {
    const dispatch = useDispatch();

    const changeTheme = (themeName) => {
        localStorage.setItem('themeName', themeName);

        dispatch({
            type: actionTypes.SET_THEME_NAME,
            themeName
        });
    };

    return (
        <Stack direction="row" spacing={1} flexWrap="wrap">
            {themeColors.map((item) => (
                <Tooltip title={item.name} key={item.name}>
                    <Box
                        onClick={() => changeTheme(item.name)}
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: '50%',
                            bgcolor: item.color,
                            cursor: 'pointer',
                            border: '2px solid #fff',
                            boxShadow: 2,
                            transition: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.1)'
                            }
                        }}
                    />
                </Tooltip>
            ))}
        </Stack>
    );
};

export default ThemeSwitcher;
